<div [hidden]="detailSaleReportLoading">
    <canvas baseChart
            [datasets]="detailSaleReportChartData"
            [labels]="detailSaleReportChartLabels"
            [legend]="lineChartLegend"
            [chartType]="'bar'"
            [options]="lineChartOptions"
            [plugins]="detailSaleChartPlugins"></canvas>
</div>
<app-report-loading *ngIf="detailSaleReportLoading"></app-report-loading>